import { render, staticRenderFns } from "./sideSearch.vue?vue&type=template&id=172edeff&scoped=true"
import script from "./sideSearch.vue?vue&type=script&lang=js"
export * from "./sideSearch.vue?vue&type=script&lang=js"
import style0 from "./sideSearch.vue?vue&type=style&index=0&id=172edeff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172edeff",
  null
  
)

export default component.exports